

import { TimeConstants } from "./time";

import { fetchUserValidation } from "./server-fetch";



const DEBUG = process.env.MODE === "DEBUG";

const DEBUG_POLLING_INTERVAL = 1 * TimeConstants.ONE_MINUTE_MILLIS;
const PROD_POLLING_INTERVAL = 5 * TimeConstants.ONE_MINUTE_MILLIS; // TODO: Decide what want in Prod



class UserValidationPolling {
  //static USER_POLLING_INTERVAL = TimeConstants.ONE_HOUR_MILLIS;
  //static USER_POLLING_INTERVAL = 5 * TimeConstants.ONE_SECOND_MILLIS; // TODO: FOR TESTING
  static USER_POLLING_INTERVAL = DEBUG ? DEBUG_POLLING_INTERVAL : PROD_POLLING_INTERVAL;

  static async checkUserValidation() {
    try {
      const userValid = await fetchUserValidation();

      return userValid;
    } catch( error ) {
      console.error( "Error - Failed to check User Validation. ", error );
    }
  }
}



export {
  UserValidationPolling,
}
